import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ajax-loader.gif'


const _withScopeId = n => (_pushScopeId("data-v-6a69d930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "client-search" }
const _hoisted_2 = {
  key: 0,
  class: "search-result-overlay"
}
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "spinner-icon p-2",
  src: _imports_0
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "result-client-name" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "result-client-id"
}
const _hoisted_11 = {
  key: 1,
  class: "result-client-id"
}
const _hoisted_12 = {
  key: 2,
  class: "no-search-result"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dropdown, {
      modelValue: _ctx.searchCategory,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCategory) = $event)),
      options: _ctx.searchCategories,
      "option-label": "label",
      "option-disabled": "disabled",
      placeholder: "Select",
      class: "mr-2 rounded-left",
      "panel-class": "search-dropdown-panel"
    }, null, 8, ["modelValue", "options"]),
    _createElementVNode("span", {
      class: _normalizeClass(["p-input-icon-right search-text-field", { disable: !_ctx.searchCategory }])
    }, [
      _createElementVNode("i", {
        class: "pi pi-search search-icon",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.performSearch && _ctx.performSearch(...args)))
      }),
      _createVNode(_component_InputText, {
        modelValue: _ctx.searchVal,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchVal) = $event)),
        type: "text",
        autocomplete: "off",
        placeholder: "Search",
        class: "rounded-right w-full client-search-input",
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleAccountSearch(_ctx.searchVal)))
      }, null, 8, ["modelValue"]),
      (_ctx.showOverlay)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
              : (_ctx.investmentAccountList.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investmentAccountList, (account) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: account.accountId,
                        onClick: ($event: any) => (_ctx.goToAccountDetail(account))
                      }, [
                        _createElementVNode("label", _hoisted_8, [
                          _hoisted_9,
                          _createTextVNode(" " + _toDisplayString(account.clientName), 1)
                        ]),
                        (account.accountId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Account ID " + _toDisplayString(account.accountId), 1))
                          : _createCommentVNode("", true),
                        (account.policyNumber)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Policy ID " + _toDisplayString(account.policyNumber), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_7))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_12, [
                    _createTextVNode(" No results found for "),
                    _hoisted_13,
                    _createTextVNode(" “" + _toDisplayString(_ctx.searchVal) + "” ", 1)
                  ]))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}